import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import TrustStrip from '../components/TrustStrip';
import SeoBenefitsSection from '../components/SeoBenefitsSection';
import FleetSection from '../components/FleetSection';
import HowItWorks from '../components/HowItWorks';
import PopularRoutes from '../components/PopularRoutes';
import ReviewsSection from '../components/ReviewsSection';
import Footer from '../components/Footer';
import MobileStickyButton from '../components/MobileStickyButton';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      <main>
        <HeroSection />
        <TrustStrip />
        <SeoBenefitsSection />
        <ReviewsSection />
        <PopularRoutes />
        <HowItWorks />
        <FleetSection />
      </main>
      <Footer />
      <MobileStickyButton />
    </div>
  );
};

export default HomePage;
